import { type ReactNode } from 'react';
import { ThemeContext, useThemeProvider } from '@/hooks/useTheme';

interface ThemeProviderProps {
  children: ReactNode;
  /** Default theme to use if no preference is stored */
  defaultTheme?: 'light' | 'dark' | 'system';
}

/**
 * Theme Provider Component
 * 
 * Wraps the application to provide theme context.
 * Should be placed near the root of the component tree.
 * 
 * @example
 * ```tsx
 * <ThemeProvider defaultTheme="system">
 *   <App />
 * </ThemeProvider>
 * ```
 */
export function ThemeProvider({ children, defaultTheme = 'system' }: ThemeProviderProps) {
  const themeValue = useThemeProvider(defaultTheme);

  return (
    <ThemeContext.Provider value={themeValue}>
      {children}
    </ThemeContext.Provider>
  );
}
